export default __webpack_public_path__ + "static/media/compiegne.91d08b4c.jpg";